var ValidUtils;
((ValidUtils2) => {
  ValidUtils2.isArrowFunction = (fn) => {
    if (typeof fn !== "function") {
      return false;
    }
    return typeof fn.prototype === "undefined" && !fn.toString().startsWith("class");
  };
  ValidUtils2.isPlainObject = (obj) => {
    return obj !== null && typeof obj === "object" && obj.constructor === Object;
  };
  const isConstructorLike = (fn) => {
    return typeof fn === "function" && typeof fn.prototype !== "undefined";
  };
  ValidUtils2.isUrl = (str) => {
    try {
      new URL(str);
      return true;
    } catch (_) {
      return false;
    }
  };
  ValidUtils2.isGenerator = (value) => {
    return value !== null && typeof value === "object" && typeof value.next === "function" && typeof value[Symbol.iterator] === "function";
  };
  ValidUtils2.isAsyncGenerator = (value) => {
    return value !== null && typeof value === "object" && typeof value.next === "function" && typeof value[Symbol.asyncIterator] === "function";
  };
  ValidUtils2.isFrozen = (obj) => {
    return Object.isFrozen(obj);
  };
  ValidUtils2.isSealed = (obj) => {
    return Object.isSealed(obj);
  };
  ValidUtils2.isFrozenOrSealed = (obj) => {
    return ValidUtils2.isFrozen(obj) || ValidUtils2.isSealed(obj);
  };
  ValidUtils2.isFrozenAndSealed = (obj) => {
    return ValidUtils2.isFrozen(obj) && ValidUtils2.isSealed(obj);
  };
  ValidUtils2.isNotFrozen = (obj) => {
    return !Object.isFrozen(obj);
  };
  ValidUtils2.isNotSealed = (obj) => {
    return !Object.isSealed(obj);
  };
  ValidUtils2.isNotFrozenOrSealed = (obj) => {
    return !ValidUtils2.isFrozen(obj) && !ValidUtils2.isSealed(obj);
  };
  ValidUtils2.isNotFrozenAndSealed = (obj) => {
    return !ValidUtils2.isFrozen(obj) || !ValidUtils2.isSealed(obj);
  };
  ValidUtils2.isNullOrUndefined = (data) => {
    return data == null || void 0 === data;
  };
  ValidUtils2.isClassType = (obj) => {
    return typeof obj === "function" && /^\s*class\s+/.test(obj.toString());
  };
  ValidUtils2.isFunctionType = (obj) => {
    return typeof obj === "function";
  };
  ValidUtils2.isNullish = (data) => {
    return ValidUtils2.isNotNullish(data);
  };
  ValidUtils2.isNotNullish = (data) => {
    if (Array.isArray(data) || ValidUtils2.isString(data)) {
      return data.length > 0;
    }
    if (data instanceof Set || data instanceof Map) {
      return data.size > 0;
    }
    if (typeof data === "object" && data !== null) {
      return Object.keys(data).length > 0;
    }
    return data !== null && data !== void 0;
  };
  function isDefined(value) {
    return value !== null && value !== void 0;
  }
  ValidUtils2.isDefined = isDefined;
  ValidUtils2.isNotNullUndefined = (data) => {
    return isDefined(data);
  };
  ValidUtils2.isNormalAttrEntry = (entry) => {
    return isDefined(entry);
  };
  ValidUtils2.isStringEntry = (entry) => {
    return isDefined(entry);
  };
  ValidUtils2.isNull = (data) => {
    return data === null;
  };
  ValidUtils2.isUndefined = (data) => {
    return data === void 0;
  };
  ValidUtils2.isArray = (object_o) => {
    if (ValidUtils2.isNullOrUndefined(object_o)) {
      return false;
    } else {
      return Object.prototype.toString.call(object_o).trim() === "[object Array]";
    }
  };
  ValidUtils2.isStringNumber = (value) => {
    if (typeof value === "number") {
      return !isNaN(value);
    }
    return typeof value === "string" && value.trim() !== "" && !isNaN(Number(value));
  };
  ValidUtils2.isNumber = (object_o) => {
    if (ValidUtils2.isNullOrUndefined(object_o)) {
      return false;
    } else {
      return Object.prototype.toString.call(object_o).trim() === "[object Number]";
    }
  };
  ValidUtils2.isIterator = (object_o) => {
    return object_o != null && typeof object_o[Symbol.iterator] === "function";
  };
  ValidUtils2.isString = (object_o) => {
    if (ValidUtils2.isNullOrUndefined(object_o)) {
      return false;
    } else {
      return Object.prototype.toString.call(object_o).trim() === "[object String]";
    }
  };
  ValidUtils2.isObject = (object_o) => {
    if (ValidUtils2.isNullOrUndefined(object_o)) {
      return false;
    } else {
      return Object.prototype.toString.call(object_o).trim() === "[object Object]";
    }
  };
  ValidUtils2.isMap = (object_o) => {
    if (ValidUtils2.isNullOrUndefined(object_o)) {
      return false;
    } else {
      return Object.prototype.toString.call(object_o).trim() === "[object Map]";
    }
  };
  ValidUtils2.isEmpty = (object_o) => {
    if (ValidUtils2.isNullOrUndefined(object_o)) {
      return true;
    } else if (ValidUtils2.isArray(object_o)) {
      return object_o.length === 0;
    } else if (ValidUtils2.isString(object_o)) {
      return object_o.trim().length === 0;
    } else if (ValidUtils2.isMap(object_o)) {
      return object_o.size === 0;
    } else if (ValidUtils2.isObject(object_o)) {
      return Object.keys(object_o).length === 0;
    } else {
      return false;
    }
  };
  ValidUtils2.isSet = (data) => {
    return data instanceof Set;
  };
  ValidUtils2.isNullishFiltered = (value) => {
    if (Array.isArray(value)) {
      return value.every((it) => it !== void 0 && it !== null);
    }
    return value !== void 0 && value !== null;
  };
  ValidUtils2.isFalsyFiltered = (value) => {
    if (Array.isArray(value)) {
      return value.every((it) => {
        return it;
      });
    }
    return !!value;
  };
  ValidUtils2.includeValue = (obj, value) => {
    return Object.values(obj).includes(value);
  };
  ValidUtils2.includeKey = (obj, key) => {
    return Object.keys(obj).includes(key);
  };
  ValidUtils2.lastConsonantLetter = (value) => {
    const lastLetter = value.charCodeAt(value.length - 1);
    return (lastLetter - 44032) % 28 > 0;
  };
  ValidUtils2.inRange = (value, min, max) => {
    return min <= value && value <= max;
  };
  ValidUtils2.isBase64 = (inputString) => {
    let base64Data = inputString;
    const parts = inputString.split(";base64,");
    if (parts.length > 1) {
      base64Data = parts[1];
    } else {
      if (inputString.startsWith("data:")) {
        const commaIndex = inputString.indexOf(",");
        if (commaIndex > -1) {
          base64Data = inputString.substring(commaIndex + 1);
        } else {
        }
      }
    }
    const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    if (base64Data === "" || base64Data.length % 4 !== 0) {
    }
    return base64Regex.test(base64Data);
  };
})(ValidUtils || (ValidUtils = {}));
export {
  ValidUtils
};
//# sourceMappingURL=ValidUtils.js.map
